import { render, staticRenderFns } from "./RazaoCardInfo.vue?vue&type=template&id=2799acf5&scoped=true"
import script from "./RazaoCardInfo.vue?vue&type=script&lang=js"
export * from "./RazaoCardInfo.vue?vue&type=script&lang=js"
import style0 from "./RazaoCardInfo.vue?vue&type=style&index=0&id=2799acf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799acf5",
  null
  
)

export default component.exports